import { Stack } from '#core/components';
import {
  AllItemsIcon,
  BookmarkIcon,
  ImageIcon,
  NoteIcon,
  StarIcon,
  TaskIcon,
  TrashIcon
} from '#core/components/icons';
import { NavLink, SectionHeader } from '../components';

export const Collections = () => {
  return (
    <Stack>
      <SectionHeader>Collections</SectionHeader>
      <NavLink
        activeOptions={{ exact: true }}
        leftSection={<AllItemsIcon />}
        to="/search"
      >
        All items
      </NavLink>
      <NavLink
        leftSection={<NoteIcon />}
        search={{ q: 'in:notes' }}
        to="/search"
      >
        Notes
      </NavLink>
      <NavLink
        leftSection={<BookmarkIcon />}
        search={{ q: 'in:bookmarks' }}
        to="/search"
      >
        Bookmarks
      </NavLink>
      <NavLink
        leftSection={<TaskIcon />}
        search={{ q: 'in:tasks' }}
        to="/search"
      >
        Tasks
      </NavLink>
      <NavLink
        leftSection={<ImageIcon />}
        search={{ q: 'in:images' }}
        to="/search"
      >
        Images
      </NavLink>
      <NavLink
        leftSection={<StarIcon />}
        search={{ q: 'filter:favorites' }}
        to="/search"
      >
        Favorites
      </NavLink>
      <NavLink
        leftSection={<TrashIcon />}
        search={{ q: 'in:trash' }}
        to="/search"
      >
        Trash
      </NavLink>
    </Stack>
  );
};
